import {EffectCallback, useEffect} from 'react';

export const useOnceEffect = (effect: EffectCallback) => {
  useEffect(effect, []); // eslint-disable-line react-hooks/exhaustive-deps
};
